module.exports = __webpack_public_path__ + "static/img/1040.e85e8c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1040.jpg
// module id = 222
// module chunks = 0